function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1009_11838)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M76.33 59.34C92.7163 59.34 106 46.0563 106 29.67C106 13.2837 92.7163 0 76.33 0L29.67 0C13.2837 0 0 13.2837 0 29.67C0 46.0563 13.2837 59.34 29.67 59.34L76.33 59.34Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.67 54.34C16.07 54.34 5 43.27 5 29.67C5 16.07 16.07 5 29.67 5H76.32C89.92 5 100.99 16.07 100.99 29.67C100.99 43.27 89.92 54.34 76.32 54.34H29.67Z",
  stroke: "#161421",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.48 22.9897H25.67V25.8497H22.01V27.6997H24.99V30.1697H22.01V32.2297H25.83V35.1097H18.47V22.9897H18.48Z",
  fill: "#161421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.96 33.28L32.6 31.5C32.52 31.08 32.16 30.77 31.77 30.77H31.14V35.1H27.47V22.98H32.33C35.39 22.98 37.2 24.45 37.2 26.94C37.2 28.43 36.42 29.6 35.14 30.02V30.04C35.75 30.26 36.02 30.72 36.16 31.44L36.36 32.52C36.41 32.88 36.55 33.04 36.8 33.04C36.99 33.04 37.19 32.96 37.38 32.77L37.97 34.44C37.34 35 36.29 35.35 35.41 35.35C34.07 35.35 33.16 34.52 32.96 33.25V33.28ZM32.18 28.39C33.01 28.39 33.53 27.85 33.53 27.02C33.53 26.14 33.01 25.62 32.18 25.62H31.15V28.4H32.18V28.39Z",
  fill: "#161421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.9299 29.0499C38.9299 25.1399 41.0999 22.6499 44.4599 22.6499C47.3399 22.6499 49.3699 24.5399 49.6399 27.5899L46.2599 27.9999C46.0699 26.5999 45.3999 25.7699 44.4999 25.7699C43.3299 25.7699 42.5999 27.0199 42.5999 29.0499C42.5999 31.0799 43.4499 32.2599 44.7999 32.2599C45.9499 32.2599 46.7799 31.3099 46.9799 29.8099L50.3999 30.2299C50.0299 33.3799 47.8599 35.4399 44.7999 35.4399C41.2299 35.4399 38.9299 32.9199 38.9299 29.0399V29.0499Z",
  fill: "#161421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.7299 32.3697H53.5599V27.1197H53.5399C53.2699 27.6097 52.8599 27.9497 52.3199 28.1697L51.4099 25.4297C52.5399 25.0097 53.3599 24.1897 53.8499 22.9897H57.1199V32.3697H58.4699V35.1097H51.7399V32.3697H51.7299Z",
  fill: "#161421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.04 32.3697H61.87V27.1197H61.85C61.58 27.6097 61.17 27.9497 60.63 28.1697L59.72 25.4297C60.85 25.0097 61.67 24.1897 62.16 22.9897H65.43V32.3697H66.78V35.1097H60.05V32.3697H60.04Z",
  fill: "#161421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.0499 31.27L71.6699 30.63C71.6699 31.97 72.0299 32.64 72.6899 32.64C73.2999 32.64 73.6399 32.08 73.6399 31.05C73.6399 29.78 73.2999 29.14 72.6399 29.14C72.3199 29.14 71.9999 29.41 71.8099 29.82L68.8699 29.35L69.2899 23H76.4599V25.62H72.2999L72.1799 27.43C72.5199 27.11 73.1999 26.92 73.8899 26.92C75.9899 26.92 77.3099 28.51 77.3099 31.03C77.3099 33.55 75.4999 35.38 72.6599 35.38C69.8199 35.38 68.0599 33.79 68.0599 31.27H68.0499Z",
  fill: "#161421"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.58 31.27L82.2 30.63C82.2 31.97 82.56 32.64 83.22 32.64C83.83 32.64 84.17 32.08 84.17 31.05C84.17 29.78 83.83 29.14 83.17 29.14C82.85 29.14 82.53 29.41 82.34 29.82L79.4 29.35L79.82 23H86.99V25.62H82.83L82.71 27.43C83.05 27.11 83.73 26.92 84.42 26.92C86.52 26.92 87.84 28.51 87.84 31.03C87.84 33.55 86.03 35.38 83.19 35.38C80.35 35.38 78.59 33.79 78.59 31.27H78.58Z",
  fill: "#161421"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1009_11838"
}, /*#__PURE__*/React.createElement("rect", {
  width: 106,
  height: 59.34,
  fill: "white"
})));

function SvgSignErc1155(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 60,
    viewBox: "0 0 106 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignErc1155);
export default __webpack_public_path__ + "static/media/Sign_ERC1155.9eb320b7.svg";
export { ForwardRef as ReactComponent };